import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (document) =>
    present(
      repository
        .removeDocument(document)
        .then(() => document)
        .catch(() => Promise.reject(document)),
    );
}

export type { Interactor };

export { createInteractor };
